import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import classNames from "classnames";

export default function Save({ attributes }) {
  const {
    columns,
    rows,
    isChild,
    height,
    layout,
    alignItems,
    justifyContent,
    direction,
    wrap,
    gridTemplateColumns,
    gridTemplateRows,
    parentLayout,
    columnSpan, // Add columnSpan
    rowSpan, // Add rowSpan
  } = attributes;

  const blockId = "brandy-container-block";

  let customStyles = "";

  if (height?.desktop !== null) {
    customStyles += `#${blockId}.wp-block-brandy-container-block { height: var(--height-desktop); }`;
  }

  if (height?.tablet !== null) {
    customStyles += `#${blockId}.wp-block-brandy-container-block { height: var(--height-tablet); }`;
  }

  if (height?.mobile !== null) {
    customStyles += `#${blockId}.wp-block-brandy-container-block { height: var(--height-mobile); }`;
  }

  const blockProps = useBlockProps.save({
    className: classNames("wp-block-brandy-container-block", {
      "brandy-child-container-block": isChild,
      "brandy-grid-layout": layout === "grid",
      "brandy-flex-layout": layout === "flex",
      "brandy-container-multi-rows": rows?.desktop > 1,
    }),
    id: blockId,
    style: {
      ...(layout === "flex"
        ? {
            "--align-items": alignItems?.desktop || "center",
            "--justify-content": justifyContent?.desktop || "center",
            "--flex-direction": direction?.desktop || "row",
            "--flex-wrap": wrap?.desktop || "nowrap",
            "--align-items-tablet":
              alignItems?.tablet || alignItems?.desktop || "center",
            "--justify-content-tablet":
              justifyContent?.tablet || justifyContent?.desktop || "center",
            "--flex-direction-tablet":
              direction?.tablet || direction?.desktop || "row",
            "--flex-wrap-tablet": wrap?.tablet || wrap?.desktop || "nowrap",
            "--align-items-mobile":
              alignItems?.mobile ||
              alignItems?.tablet ||
              alignItems?.desktop ||
              "center",
            "--justify-content-mobile":
              justifyContent?.mobile ||
              justifyContent?.tablet ||
              justifyContent?.desktop ||
              "center",
            "--flex-direction-mobile":
              direction?.mobile ||
              direction?.tablet ||
              direction?.desktop ||
              "row",
            "--flex-wrap-mobile":
              wrap?.mobile || wrap?.tablet || wrap?.desktop || "nowrap",
          }
        : {
            "--grid-template-columns": gridTemplateColumns?.desktop?.length
              ? `${gridTemplateColumns.desktop.join(" ")}`
              : "1fr",
            "--grid-template-rows": gridTemplateRows?.desktop?.length
              ? `${gridTemplateRows.desktop.join(" ")}`
              : "1fr",
            "--grid-template-columns-tablet": gridTemplateColumns?.tablet
              ?.length
              ? `${gridTemplateColumns.tablet.join(" ")}`
              : gridTemplateColumns?.desktop?.length
              ? `${gridTemplateColumns.desktop.join(" ")}`
              : "1fr",
            "--grid-template-rows-tablet": gridTemplateRows?.tablet?.length
              ? `${gridTemplateRows.tablet.join(" ")}`
              : gridTemplateRows?.desktop?.length
              ? `${gridTemplateRows.desktop.join(" ")}`
              : "1fr",
            "--grid-template-columns-mobile": gridTemplateColumns?.mobile
              ?.length
              ? `${gridTemplateColumns.mobile.join(" ")}`
              : gridTemplateColumns?.tablet?.length
              ? `${gridTemplateColumns.tablet.join(" ")}`
              : gridTemplateColumns?.desktop?.length
              ? `${gridTemplateColumns.desktop.join(" ")}`
              : "1fr",
            "--grid-template-rows-mobile": gridTemplateRows?.mobile?.length
              ? `${gridTemplateRows.mobile.join(" ")}`
              : gridTemplateRows?.tablet?.length
              ? `${gridTemplateRows.tablet.join(" ")}`
              : gridTemplateRows?.desktop?.length
              ? `${gridTemplateRows.desktop.join(" ")}`
              : "1fr",
          }),
      ...(isChild && parentLayout === "grid"
        ? {
            "grid-column": `span ${columnSpan?.desktop ?? 1}`, // Apply column span
            "grid-row": `span ${rowSpan?.desktop ?? 1}`, // Apply row span
            "grid-column-tablet": `span ${
              columnSpan?.tablet ?? columnSpan?.desktop ?? 1
            }`,
            "grid-row-tablet": `span ${
              rowSpan?.tablet ?? rowSpan?.desktop ?? 1
            }`,
            "grid-column-mobile": `span ${
              columnSpan?.mobile ??
              columnSpan?.tablet ??
              columnSpan?.desktop ??
              1
            }`,
            "grid-row-mobile": `span ${
              rowSpan?.mobile ?? rowSpan?.tablet ?? rowSpan?.desktop ?? 1
            }`,
          }
        : {}),
      "--height-desktop":
        height?.desktop !== null ? `${height.desktop}px` : null,
      "--height-tablet": height?.tablet !== null ? `${height.tablet}px` : null,
      "--height-mobile": height?.mobile !== null ? `${height.mobile}px` : null,
    },
    "data-layout": layout,
    "data-is-child": isChild ? "true" : "false",
  });

  return (
    <div {...blockProps}>
      {customStyles && <style>{customStyles}</style>}
      {!isChild ? (
        <div
          className={`brandy-container-wrapper ${
            rows?.desktop > 1 ? "brandy-container-multi-rows" : ""
          }`}
        >
          <InnerBlocks.Content />
        </div>
      ) : (
        <InnerBlocks.Content />
      )}
    </div>
  );
}
